import { Images } from 'lucide-react';
import { LucideIcon } from '@/src/components/LucideIcon';
import * as styles from './photoGallery.styles';

type ImageCounterProps = {
  currentIndex: number;
  totalCount: number;
  onClick: () => void;
};

export const ImageCounter = ({ currentIndex, totalCount, onClick }: ImageCounterProps) => (
  <button
    className={styles.imageCounter}
    onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}
    aria-label={`Photo ${currentIndex + 1} of ${totalCount}, view all photos`}
  >
    <LucideIcon icon={Images} size="sm" />
    {currentIndex + 1} / {totalCount}
  </button>
);
